import DashboardUserStatsItem from './dashboard-user-stats-item'
import { StyledDashboardUserStatsGrid } from './dashboard-user-stats.style'

import { FiUsers } from 'react-icons/fi'
import { HiOutlineUserGroup, HiOutlineClipboardList } from 'react-icons/hi'
import { BiCoinStack } from "react-icons/bi";
// import { GrMoney } from "react-icons/gr";

const DashboardUserStats = () => {
    return (
        <StyledDashboardUserStatsGrid>
            <DashboardUserStatsItem icon={<FiUsers size={20} />} title="users" count="2,453" color="#DF18FF" bgColor="rgba(223, 24, 255, 0.1)" />
            <DashboardUserStatsItem icon={<HiOutlineUserGroup size={20} />} title="Active Users" count="2,453" color="#5718FF" bgColor="rgba(87, 24, 255, 0.1)" />
            <DashboardUserStatsItem icon={<HiOutlineClipboardList size={20} />} title="Users with Loans" count="12,453" color="#F55F44" bgColor="rgba(245, 95, 68, 0.1)" />
            <DashboardUserStatsItem icon={<BiCoinStack size={20} />} title="Users with Savings" count="102,453" color="#FF3366" bgColor='rgba(255, 51, 102, 0.1)' />
        </StyledDashboardUserStatsGrid>
    )
}

export { DashboardUserStats }